<template>
   <div class="search_container">
    <div class="serach-content">
      <input type="text" ref="myInput" @focus="focusFnChange" @keyup.enter="sure" v-model.trim="searchValue" :placeholder="placeholder" />
      <div class="bg-img" @click="sure">
        <img src="@/views/index/images/search.png" alt="search">
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { _saveSearchHistory } from '../../api/parent-course'
export default {
  name: 'common-search',
  components: {},
  props: {
    placeholder: {
      type: String,
      default: '请输入关键词'
    },
    inputKeyValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchValue: ''
    }
  },
  computed: {},
  methods: {
    sure() {
      this.saveSearchHistory({ text: this.searchValue })
      this.$emit('searchEvent', this.searchValue)
    },
    focusFn() {
      this.$refs.myInput.focus()
    },
    focusFnChange() {
      this.$emit('focusEvent')
      this.$bus.$emit('showMore', false)
    },
    // 给input赋值
    gainInputValue() {
      let key = localStorage.getItem('keyWord')
      if (key) {
        this.searchValue = key
      } else {
        this.searchValue = ''
      }
    },
    inifF() {
      this.$bus.$on('handleItem', item => {
        if (item) {
          this.searchValue = item
        }
      })
    },

    // 保存用户搜素关键词
    async saveSearchHistory(keyword) {
      try {
        let res = await _saveSearchHistory(keyword)
        let { code, data, message } = res
        if (res && code !== 200) {
          // Toast(message)
        }
      } catch (error) {}
    }
  },
  beforeCreate() {},
  created() {
    let key = localStorage.getItem('keyWord')
    if (key) {
      this.searchValue = key
    } else {
      this.searchValue = ''
    }
  },
  beforeMount() {},
  mounted() {
    this.inifF()
  },
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss">
.search_container {
  width: 100%;
  .serach-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .bg-img {
      position: absolute;
      width: 15px;
      height: 15px;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
    }
    input {
      width: 100%;
      height: 40px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.16) 0%, rgba(244, 254, 255, 0.41) 100%);
      box-shadow: 0px 1px 3vw 3px rgba(24, 190, 184, 0.2);
      border-radius: 999px;
      padding: 0 16px 0 20px;
      line-height: 30px;
      -webkit-appearance: none;
      outline: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
    input::-moz-placeholder {
      font-size: 14px;
      color: #626a6b;
    }
    input::-webkit-input-placeholder {
      font-size: 14px;
      color: #626a6b;
    }
    input::-ms-input-placeholder {
      font-size: 14px;
      color: #626a6b;
    }
    input[type='text'] {
      font-size: 14px;
      color: #626a6b;
    }
    .sure {
      height: 20px;
      font-size: 14px;
      color: #666;
      line-height: 20px;
    }
  }
}
</style>
